import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { ItemStatusEnum } from '@/modules/common';
import {
  PageHeader,
  Spinner,
  useApiMutation,
  useApiQuery,
} from '@/modules/common';
import { Routes } from '@/router/routes';

import { StylesTable } from '../components';
import { StyleItem } from '../types';

export const StylesPage: FC = () => {
  const navigate = useNavigate();

  const { isFetching, data, refetch } = useApiQuery<StyleItem[]>('/styles', {
    queryKey: ['styles'],
    initialData: [],
  });

  const archiveStyleMutation = useApiMutation<StyleItem>(
    '/styles',
    {
      method: 'PATCH',
    },
    {
      onError: () => {
        toast.error('Uh oh! Something went wrong.');
      },
    }
  );

  const toggleStyleStatus = async (style: StyleItem) => {
    await archiveStyleMutation.mutateAsync({
      ...style,
      status:
        style.status === ItemStatusEnum.Archived
          ? ItemStatusEnum.Ready
          : ItemStatusEnum.Archived,
    });
    return await refetch();
  };

  const redirectToStyleDetails = (item) => {
    navigate(Routes.StyleDetails.replace(':id', item.id));
  };

  return (
    <div>
      <PageHeader
        title="Styles"
        actions={[
          <Link
            to={Routes.NewStyle}
            key="new-style"
            data-testid="add-new-style-link"
          >
            <Button disabled={isFetching} data-testid="add-new-model-button">
              <PlusSquareIcon />
              Add new style
            </Button>
          </Link>,
        ]}
      />

      {isFetching ? (
        <Spinner />
      ) : (
        <StylesTable
          data={data}
          toggleStatus={toggleStyleStatus}
          onClick={redirectToStyleDetails}
        />
      )}
    </div>
  );
};
